import React from 'react';
// Data
import { fullServicesArray } from '../../utils/data/ServicesData';
// Constants
import { CompanyName, CompanyPhoneNumber } from '../../utils/Constants';

function FullListOfServices() {
  return (
    <section
      className='grid w-full bg-colour1 py-6 lg:py-10'
      id='main-services'
    >
      <div className='grid gap-8 px-6 pt-4 xs:px-10 sm:px-16 md:px-24 lg:container lg:mx-auto'>
        {/* Header */}
        <section className='grid text-center'>
          <h4 className='text-4xl'>Full Services</h4>
          <h5 className='text-lg mt-1'>{CompanyName}</h5>
          <p className='mt-2 text-lg'>
            We offer a wide range of expert construction services tailored to
            your needs.
          </p>
          <p>
            If you don’t see what you are looking for, call and we can discuss
            your needs.
          </p>
          <div>
            <a
              href={`tel:${CompanyPhoneNumber}`}
              className='text-colour2'
              aria-label={`Call me now at ${CompanyPhoneNumber}`}
            >
              <span className='font-medium text-colour5 text-xl'>
                {CompanyPhoneNumber}
              </span>
            </a>
          </div>
        </section>

        <section className='grid gap-4 lg:gap-6 w-full text-center'>
          {fullServicesArray.map((service, index) => (
            <article
              key={service.label}
              className={`grid w-full h-full ${
                index === 0
                  ? 'bg-colour4'
                  : index === 1
                  ? 'bg-colour5'
                  : index === 2
                  ? 'bg-colour6'
                  : 'bg-colour5'
              } p-2 shadow-cardShadow lg:max-h-[60vh] overflow-hidden`}
            >
              <div className='grid grid-rows-reg lg:grid-cols-2 border-colour1 border-2 border-solid overflow-hidden'>
                {/* Image Section (Always on top for small screens, alternates on lg screens) */}
                <section
                  className={`w-full h-full overflow-hidden ${
                    index % 2 !== 0 ? 'lg:order-last' : ''
                  }`}
                >
                  <img
                    src={service.imageUrl} // Replace with dynamic service images if available
                    alt={service.label}
                    className='w-full h-full object-cover'
                  />
                </section>

                {/* Text Section */}
                <section
                  className={`grid gap-4 justify-center text-center px-6 pt-4 pb-6 border-t-2 lg:border-t-0 lg:border-l-2 border-solid border-colour1 ${
                    index % 2 ? 'lg:border-r-2' : 'lg:border-l-2'
                  }`}
                >
                  <div className='grid h-full items-center'>
                    <div className='grid gap-4'>
                      <div className='grid h-fit gap-1'>
                        <h3 className='text-xl lg:text-2xl leading-5 uppercase font-semibold max-w-[15ch] mx-auto'>
                          {service.label}
                        </h3>
                      </div>
                      {service.subcategories.length > 0 && (
                        <ul className='grid list-disc text-xs list-inside md:text-sm lg:text-base'>
                          {service.subcategories.map((sub, subIndex) => (
                            <li key={subIndex}>{sub}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </article>
          ))}
        </section>
      </div>
    </section>
  );
}

export default FullListOfServices;
